// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { Currency, type CurrencyWireFormat, NewCurrency } from '../Currency/Currency';
import {
  NewQuotePriceEscalation,
  QuotePriceEscalation,
  type QuotePriceEscalationWireFormat,
} from '../QuotePriceEscalation/QuotePriceEscalation';

export class QuoteProductCurrentPriceStep {
  readonly escalation: QuotePriceEscalation;
  readonly price: Currency;

  constructor(data: { [key: string]: any } = {}) {
    this.escalation = NewQuotePriceEscalation(data.escalation);
    this.price = NewCurrency(data.price);
  }

  static zero(): QuoteProductCurrentPriceStep {
    const zeroValues: ExcludeMethodsDeep<QuoteProductCurrentPriceStep> = {
      escalation: QuotePriceEscalation.zero(),
      price: Currency.zero(),
    };
    return new QuoteProductCurrentPriceStep(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteProductCurrentPriceStepWireFormat = {
  escalation: QuotePriceEscalationWireFormat;
  price: CurrencyWireFormat;
};

type NewQuoteProductCurrentPriceStepProps = PartialDeep<
  QuoteProductCurrentPriceStep,
  { recurseIntoArrays: true }
>;
export const NewQuoteProductCurrentPriceStep: (
  props: NewQuoteProductCurrentPriceStepProps,
) => QuoteProductCurrentPriceStep = (props) => new QuoteProductCurrentPriceStep(props);

type NewQuoteProductCurrentPriceStepFromWireFormatProps = PartialDeep<
  QuoteProductCurrentPriceStepWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteProductCurrentPriceStepFromWireFormat: (
  props: NewQuoteProductCurrentPriceStepFromWireFormatProps,
) => QuoteProductCurrentPriceStep = (props) => new QuoteProductCurrentPriceStep(props);
